export const desktopRelease = {
  version: "1.0.1",
  // Set this to the public GitHub Release or Microsoft Store URL after the
  // first hardware-validated desktop release. Leaving it blank keeps the
  // download button safely disabled on the public site.
  downloadUrl: "",
  status: "hardware-validation" as const,
}

export const links = {
  guardians: "https://store.steampowered.com/app/3025060/THE_GUARDIANS/",
  corporeal: "https://store.steampowered.com/app/3260970/CORPOREAL/",
  neutronSteam: "https://store.steampowered.com/curator/45224131",
  neutronSite: "https://neutrongamestudios.com/",
  appleWindows: "https://support.apple.com/guide/devices-windows/welcome/windows",
}
